export const ZOOM_FACTOR = 0.25;
export const ZOOM_MIN_SCALE = 0.5;
export const ZOOM_MAX_SCALE = 2;

// closest distance from the edge of the screen to trigger panning with max-speed
export const EDGE_PAN_THRESHOLD = 80;

// panning speed i'e how fast the viewport moves when panning per pixel
export const AUTO_PAN_SPEED = 8;

export const ZOOM_ANIMATION_DURATION = 250;

// TODO: Remove this magic number. This is the height of the top bar in the viewport.
// This is to ensure that we're offsetting the threshold when checking the top edge.
export const TOP_EDGE_OFFSET = 42;

export const VIEWPORT_INITIAL_OFFSET_X = 100;
export const VIEWPORT_INITIAL_OFFSET_Y = 100;
